import PersonalVideoIcon from '@mui/icons-material/PersonalVideo';
import QrCodeIcon from '@mui/icons-material/QrCode';
import { CircularProgress } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import { useEffect } from 'react';
import {
  actionButtonStyle,
  contentGridStyle,
  dialogContentStyle,
  highlightedWordStyle,
  monitorCardStyle,
  monitorCircleStyle,
  monitorIconStyle,
  popupTitleStyle,
  qrCardStyle,
  qrHeaderIconStyle,
  qrHeaderWrapperStyle,
  qrIconStyle,
  qrImageStyle,
  rightColumnStyle,
  sectionDescriptionStyle,
  sectionTitleStyle,
} from '../styles/IncodeOnBoardingStyles';

const IncodeOnboardingPopup = ({
  onClose,
  open,
  incodeLinksDialog,
  incodeLinksLoading,
  getIncodeStatusExecute,
}) => {
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (open) {
        e.preventDefault();
        e.returnValue = '';
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [open]);

  return (
    <Dialog
      onClose={(event, reason) => {
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
        if (onClose) onClose(event, reason);
      }}
      open={open}
      maxWidth={'md'}
    >
      <DialogContent sx={dialogContentStyle}>
        {incodeLinksLoading ? (
          <Box
            width={'25rem'}
            height={'30rem'}
            alignContent={'center'}
            display={'flex'}
            justifyContent={'center'}
            alignItems={'center'}
          >
            <CircularProgress />
          </Box>
        ) : (
          <>
            <Box sx={qrHeaderWrapperStyle}>
              <Box sx={qrIconStyle}>
                <QrCodeIcon sx={qrHeaderIconStyle} />
              </Box>
            </Box>

            <Typography variant='h5' sx={popupTitleStyle}>
              Verificación biométrica
            </Typography>

            <Box sx={contentGridStyle}>
              <Box>
                <Typography sx={sectionTitleStyle}>
                  En{' '}
                  <Box component='span' sx={highlightedWordStyle}>
                    otro
                  </Box>{' '}
                  dispositivo
                </Typography>

                <Typography sx={sectionDescriptionStyle}>
                  Escanea el código con la cámara del dispositivo donde harás la vinculación.
                </Typography>

                <Box sx={qrCardStyle}>
                  <Box
                    component='img'
                    src={incodeLinksDialog?.url_qr_image}
                    alt='Codigo QR para vinculacion'
                    sx={qrImageStyle}
                  />
                </Box>

                <Button
                  variant='contained'
                  fullWidth
                  sx={actionButtonStyle}
                  onClick={() => getIncodeStatusExecute(incodeLinksDialog?.uuid)}
                >
                  Finalizar vinculación
                </Button>
              </Box>

              <Box sx={rightColumnStyle}>
                <Typography sx={sectionTitleStyle}>
                  En{' '}
                  <Box component='span' sx={highlightedWordStyle}>
                    este
                  </Box>{' '}
                  dispositivo
                </Typography>

                <Typography sx={sectionDescriptionStyle}>
                  Da clic en el botón para realizar la vinculación en el navegador.
                </Typography>

                <Box sx={monitorCardStyle}>
                  <Box sx={monitorCircleStyle}>
                    <PersonalVideoIcon sx={monitorIconStyle} />
                  </Box>
                </Box>

                <Button variant='contained' fullWidth sx={actionButtonStyle}>
                  <a
                    href={incodeLinksDialog?.url}
                    target='_blank'
                    rel='noopener noreferrer'
                    style={{ textDecoration: 'none', color: 'inherit' }}
                  >
                    Vincular en este dispositivo
                  </a>
                </Button>
              </Box>
            </Box>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default IncodeOnboardingPopup;
